import * as sdk from "boa-sdk-ts";
import { WalletMA } from "boa-sdk-ts";

export const COIN_NET = "COIN";
export const TEST_NET = "TEST";

const defaultState = {
  frontSlice: 12,
  middleCharacter: `…`,
  lastSlice: 12,
};

export const isLockPeriod = (transaction) => {
  let flag = false;
  if (
    transaction &&
    transaction.hasOwnProperty("unlock_height") &&
    transaction.hasOwnProperty("height")
  ) {
    let height =
      parseInt(transaction.unlock_height) - parseInt(transaction.height);
    flag = height > 1;
  }
  return flag;
};

export const addressFormat = (
  publicKey,
  frontSlice = defaultState.frontSlice,
  lastSlice = defaultState.lastSlice
) => {
  if (publicKey && publicKey.length > 0) {
    return (
      publicKey.slice(0, frontSlice) +
      defaultState.middleCharacter +
      publicKey.slice(-1 * lastSlice)
    );
  } else {
    return "";
  }
};
export const amountFormat = (amount, numberOfDigit = 7) => {
  let isNegative = false;
  let strAmount;
  if (amount) {
    strAmount = amount.toString();
  } else {
    strAmount = "0";
  }

  if (strAmount.indexOf("-") > -1) {
    isNegative = true;
    strAmount = strAmount.replace("-", "");
  }
  let formatAmount = sdk.AmountConverter.toString(
    new sdk.Amount(sdk.JSBI.BigInt(strAmount)),
    true,
    numberOfDigit
  );
  return isNegative ? "-".concat(formatAmount) : formatAmount;
};

export const getPayloadFee = (payload) => {
  return sdk.TxPayloadFee.getFee(Buffer.from(payload, "base64").length);
};
export const saveWalletData = () => {
  const json = WalletMA.instance().accounts.toString();
  localStorage.setItem("Accounts", json);
};
export const getWalletData = () => {
  let localAccountList = undefined;
  try {
    localAccountList = JSON.parse(localStorage.getItem("Accounts"));
    localAccountList = localAccountList ? localAccountList : [];
  } catch (e) {
    localAccountList = [];
    clearWalletData();
  }
  return localAccountList;
};
export const loadWalletData = () => {
  try {
    const localAccountList = localStorage.getItem("Accounts");
    WalletMA.instance().accounts.fromString(localAccountList);
  } catch (e) {}
};
export const clearWalletData = () => {
  localStorage.setItem("Accounts", "");
};
export const loadContactList = () => {
  let localAccountList = undefined;
  try {
    localAccountList = JSON.parse(localStorage.getItem("Contact"));
    localAccountList = localAccountList ? localAccountList : [];
  } catch (e) {
    localAccountList = [];
    localStorage.setItem("Contact", "");
  }
  return localAccountList;
};
export const saveContactList = (list) => {
  localStorage.setItem("Contact", JSON.stringify(list));
};

export const getDuplicateFilter = (baseList, excludeList) => {
  let list = [];
  baseList.forEach((rItem) => {
    let flag = true;
    excludeList.forEach((sItem) => {
      if (sItem.address.toString() === rItem.address.toString()) {
        flag = false;
      }
    });
    if (flag) {
      list.push(rItem);
    }
  });
  return list;
};

export const loadNetworksURL = () => {
  try {
    return JSON.parse(localStorage.getItem("Network"));
  } catch (e) {}
  return undefined;
};

export const saveNetworkStatus = (status) => {
  localStorage.setItem("NetworkStatus", status);
};

export const loadNetworkStatus = () => {
  try {
    return localStorage.getItem("NetworkStatus");
  } catch (e) {}
  return undefined;
};

export const saveNetworksURL = (type, agoraURL, stoaURL) => {
  let nData = loadNetworksURL();
  if (!nData) {
    nData = {};
  }
  nData[type] = {
    agora: agoraURL,
    stoa: stoaURL,
  };
  localStorage.setItem("Network", JSON.stringify(nData));
};
export const getNetworksURL = (type) => {
  let network;
  // FIXME : Only TestNet
  type = "TEST";
  try {
    const n = loadNetworksURL();
    if (n && n[type] !== undefined) {
      network = n[type];
    } else {
      network = {
        agora: process.env["REACT_APP_" + type + "_NET_AGORAURL"],
        stoa: process.env["REACT_APP_" + type + "_NET_STOAURL"],
      };
    }
  } catch (e) {}
  return network;
};
